import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Resource } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  addPlanzoneResourceToProject(
    request: Boundaries["addPlanzoneResourceToProject"]["request"],
  ): void;
}

function useAddPlanzoneResourceToProject(
  resource: Identifiable<Resource>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isAddPlanzoneResourceToProjectRequestPending(resource),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isAddPlanzoneResourceToProjectRequestSuccess(resource),
    ),
    isRequestFailure: useSelector(() =>
      selector.isAddPlanzoneResourceToProjectRequestFailure(resource),
    ),
    addPlanzoneResourceToProject: core.addPlanzoneResourceToProject,
  };
}

export { useAddPlanzoneResourceToProject };
